import React from "react";
import Tooltip from "@mui/material/Tooltip";
import "./Skill.css";

const Skill = ({ description, image }) => {
  return (
    <Tooltip title={description}>
      <img className="tool" src={image} alt={description} />
    </Tooltip>
  );
};

export default Skill;
